import { useEffect, useMemo, useState } from "react";

export const PAGE_SIZE_OPTIONS = [10, 20, 50];

/**
 * Client-side pagination over an already-filtered list. Jumps back to page 1
 * whenever `resetKey` changes (pass the active filters), and clamps to the
 * last page when items disappear (e.g. an order is completed).
 */
export const usePagination = (items, initialPageSize = 20, resetKey = "") => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const current = Math.min(page, pageCount);

  const pageItems = useMemo(
    () => items.slice((current - 1) * pageSize, current * pageSize),
    [items, current, pageSize]
  );

  return {
    page: current,
    pageCount,
    pageSize,
    total: items.length,
    pageItems,
    setPage,
    setPageSize: (size) => {
      setPageSize(size);
      setPage(1);
    },
  };
};

/** Case-insensitive "does any of these fields contain the search term" — an empty term matches everything. */
export const matchesSearch = (term, ...fields) => {
  const needle = term.trim().toLowerCase();
  return !needle || fields.some((field) => String(field ?? "").toLowerCase().includes(needle));
};
